"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionList = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var sok_ui_1 = require("@caddigital/sok-ui");
var permissionsActions = require("@caddigital/sok-reducers/lib/actions/project/permissions");
var permissions_1 = require("@caddigital/sok-reducers/lib/utils/permissions");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var avatars_1 = require("components/Avatar/avatars");
var TableRowIcon_1 = require("components/TableRowIcon");
var utils_1 = require("components/MemberList/utils");
var Types = require("types");
require("./permissionList.scss");
var groupColumns = ['group', 'read', 'write', 'delete', 'subfolders'];
var userColumns = ['user', 'company'];
// STATE
var mapStateToProps = function (state) {
    return {
        groups: state.project.members.groups,
        permissions: state.project.permissions,
        notifications: state.project.permissions.notifications,
        folderNotifications: state.project.permissions.folderNotifications,
        collapsed: state.project.permissions.collapsed,
        selectedFolder: state.project.permissions.folderTree.target,
        processed: state.project.permissions.processed,
        processing: state.project.permissions.processing,
        permissionStatus: state.project.permissions.currentPermissions.status,
        membersStatus: state.project.members.status,
        disableAll: state.project.permissions.currentPermissions.status !== 'FETCHED',
        saveStatus: state.project.permissions.saveStatus,
        folderStatus: state.project.permissions.folderTree.data.status,
        viewport: state.viewport
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    expandOrCollapseRow: function (groups, isCollapsed) {
        return dispatch(permissionsActions.collapseUserGroupRow(groups, isCollapsed));
    },
    updatePermission: function (groups, folderIndetifier, permission, newFolder, status) {
        return dispatch(permissionsActions.updatePermission(groups, folderIndetifier, permission, newFolder, status));
    },
    toggleNewFolderPermission: function (groups, folder, status) {
        return dispatch(permissionsActions.toggleNewFolderPermission(groups, folder, status));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var permissionListFeatures = ['FILESTAB'];
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('PermissionList'), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var data = (0, utils_1.filterCategories)(this.props.groups.filter(function (x) {
            return x.category.type !== 'ProjectAdminUserGroup' && x.groups.length > 0;
        }), this.props.permissions.searchString, undefined, permissionListFeatures);
        this.props.setItems((0, utils_1.mapData)(data, this.props.permissions.collapsed, 0));
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.items;
        if (this.props.groups !== prevProps.groups ||
            this.props.permissions.searchString !==
                prevProps.permissions.searchString ||
            this.props.permissions.collapsed !== prevProps.permissions.collapsed ||
            (this.props.permissions.currentPermissions.status === 'FETCHED' &&
                this.props.permissions.currentPermissions.status !==
                    prevProps.permissions.currentPermissions.status) ||
            this.props.processed !== prevProps.processed) {
            var data = (0, utils_1.filterCategories)(this.props.groups.filter(function (x) {
                return x.category.type !== 'ProjectAdminUserGroup' && x.groups.length > 0;
            }), this.props.permissions.searchString, undefined, permissionListFeatures);
            items = (0, utils_1.mapData)(data, this.props.permissions.collapsed, 0);
            this.props.setItems(items);
        }
        if (items !== prevProps.items ||
            this.props.permissions.collapsed !== prevProps.permissions.collapsed) {
            var allColumns_1 = __spreadArray(__spreadArray([], groupColumns, true), userColumns, true);
            var contentWidth_1 = 0;
            var columns_1 = items.reduce(function (p, item) {
                allColumns_1.forEach(function (x) {
                    var dataKey = '__' + x.replace(/-/g, '');
                    switch (x) {
                        case 'group': {
                            var length = 0;
                            if (item.type !== 'USER') {
                                length = (0, text_1.calculateStringLength)((0, utils_1.getGroupName)(item.group));
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'user': {
                            var length = 0;
                            if (item.type === 'USER') {
                                var name = (0, text_1.calculateStringLength)((0, utils_1.getName)(item.user));
                                var email = (0, text_1.calculateStringLength)(item.user.email);
                                length = (email > name ? email : name) + 2.3 * 13;
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                        case 'company': {
                            var length = 0;
                            if (item.type === 'USER') {
                                length = (0, text_1.calculateStringLength)(item.user.company || '');
                            }
                            if (!p[dataKey] || p[dataKey] < length) {
                                p[dataKey] = length;
                            }
                            break;
                        }
                    }
                });
                return p;
            }, {});
            allColumns_1.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var length = 0;
                switch (x) {
                    case 'group': {
                        var text = (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/title');
                        length = (0, text_1.calculateStringLength)(text);
                        break;
                    }
                    case 'user':
                    case 'company':
                        // Ignore fields
                        break;
                    default: {
                        var text = (0, translation_1.getLocalization)("userfront/project/FolderPermissionsView/PermissionList/".concat(x));
                        length =
                            (0, text_1.calculateStringLength)(text) + 30 + (x === 'subfolders' ? 20 : 0);
                    }
                }
                if (!columns_1[dataKey] || columns_1[dataKey] < length) {
                    columns_1[dataKey] = length;
                }
            });
            // Override styles for dynamic classes
            var style = document.getElementById('ProjectTeamMembersPermissionListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'ProjectTeamMembersPermissionListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 5 * 13 + 6.75 * 13;
            var userContentWith_1 = contentWidth_1;
            allColumns_1.forEach(function (x, i) {
                var dataKey = '__' + x.replace(/-/g, '');
                var colwidth = Math.max(8, 4 + columns_1[dataKey] + 26); // convert to rem
                if (groupColumns.includes(x)) {
                    contentWidth_1 += colwidth;
                }
                else if (userColumns.includes(x)) {
                    userContentWith_1 += colwidth;
                }
                sheet_1.insertRule(".".concat(dataKey) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1 > userContentWith_1 ? contentWidth_1 : userContentWith_1);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        var keys = Object.keys(this.props);
        var update = false;
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (this.props[key] !== nextProps[key]) {
                update = true;
            }
        }
        return update;
    }
}), recompose_1.pure);
function getPermission(processing, processed, selectedFolder) {
    if (!selectedFolder) {
        return {
            hasAll: permissions_1.ACL_PERM_NONE,
            hasAllCustomerGroups: permissions_1.ACL_PERM_NONE,
            categories: {},
            groups: {},
            disabledGroupIds: []
        };
    }
    var permissions = processed[selectedFolder.getValue().uuid];
    if (!processing && permissions) {
        return permissions;
    }
    return {
        hasAll: permissions_1.ACL_PERM_NONE,
        hasAllCustomerGroups: permissions_1.ACL_PERM_NONE,
        categories: {},
        groups: {},
        disabledGroupIds: []
    };
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-messages', className: 'no-data' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9') }),
    React.createElement("b", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/placeHolderTitle')),
    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/placeHolderDescription')),
    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/placeHolderHelp')))); };
function getGroups(props) {
    var all = [];
    // Handle categories
    props.groups.forEach(function (c) { return c.groups.forEach(function (g) { return all.push(g.uuid); }); });
    return all;
}
var Header = function (props) {
    var hasReadable = (props.perms.hasAll & permissions_1.ACL_READ) > 0;
    var hasWritable = (props.perms.hasAll & permissions_1.ACL_WRITE) > 0;
    var hasDeletable = (props.perms.hasAll & permissions_1.ACL_DELETE) > 0;
    var hasNewFolder = (props.perms.hasAll & permissions_1.ACL_NEW_FOLDER) > 0;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: 'row__column icons' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/collapseAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-up', onClick: function () {
                        props.expandOrCollapseRow(props.groups.reduce(function (acc, item) {
                            acc.push(item.category.id);
                            return item.groups.reduce(function (ac, group) {
                                ac.push(group.id);
                                return ac;
                            }, acc);
                        }, []), true);
                    } })),
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("global/expandAll")) },
                React.createElement(sok_ui_1.Icon, { prefix: 'far', className: 'fa-chevron-square-down', onClick: function () {
                        props.expandOrCollapseRow(props.groups.reduce(function (acc, item) {
                            acc.push(item.category.id);
                            return item.groups.reduce(function (ac, group) {
                                ac.push(group.id);
                                return ac;
                            }, acc);
                        }, []), false);
                    } }))),
        React.createElement("div", { className: 'row__column __group' }, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/title')),
        React.createElement("div", { className: 'row__column fill-2' }),
        React.createElement("div", { className: 'row__column __read' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/readHeader')) },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/read'), onChange: function () {
                        return props.updatePermission(getGroups(props), props.selectedFolder.getValue().uuid, permissions_1.ACL_READ, false, !hasReadable);
                    }, value: hasReadable, disabled: props.disableAll }))),
        React.createElement("div", { className: 'row__column __write' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/writeHeader')) },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/write'), onChange: function () {
                        return props.updatePermission(getGroups(props), props.selectedFolder.getValue().uuid, permissions_1.ACL_DELETE, hasWritable ? hasNewFolder : true, !hasDeletable);
                    }, value: hasDeletable, disabled: props.disableAll }))),
        React.createElement("div", { className: 'row__column __delete' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/deleteHeader')) },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/delete'), onChange: function () {
                        return props.updatePermission(getGroups(props), props.selectedFolder.getValue().uuid, permissions_1.ACL_DELETE, hasWritable ? hasNewFolder : true, !hasDeletable);
                    }, value: hasDeletable, disabled: props.disableAll }))),
        React.createElement("div", { className: 'row__column __subfolders' },
            React.createElement("div", null,
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/subfoldersHeader')) },
                    React.createElement(sok_ui_1.Input, { type: 'checkbox', label: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/subfolders'), onChange: function () {
                            return props.toggleNewFolderPermission(getGroups(props), props.selectedFolder.getValue().uuid, !hasNewFolder);
                        }, value: hasNewFolder, disabled: props.disableAll || !hasWritable })),
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/PermissionList/tooltipSubfolders')) },
                    React.createElement(TableRowIcon_1.default, { icon: 'fa-question', circle: true, className: 'white' }))))));
};
var createRowData = function (groups, items, expandOrCollapseRow, collapsed, perms, disableAll, selectedFolder, updatePermission, toggleNewFolderPermission) { return ({
    groups: groups,
    items: items,
    expandOrCollapseRow: expandOrCollapseRow,
    collapsed: collapsed,
    perms: perms,
    disableAll: disableAll,
    selectedFolder: selectedFolder,
    updatePermission: updatePermission,
    toggleNewFolderPermission: toggleNewFolderPermission
}); };
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var row = data.items[index];
    var disabled = data.perms.disabledGroupIds.includes(row.group.id);
    var rowPerm = 0;
    if (row.type === 'CATEGORY') {
        rowPerm = data.perms.categories[row.group.uuid] || permissions_1.ACL_PERM_NONE;
    }
    else if (row.type === 'GROUP') {
        rowPerm = data.perms.groups[row.group.uuid] || permissions_1.ACL_PERM_NONE;
    }
    var hasReadable = (rowPerm & permissions_1.ACL_READ) > 0;
    var hasWritable = (rowPerm & permissions_1.ACL_WRITE) > 0;
    var hasDeletable = (rowPerm & permissions_1.ACL_DELETE) > 0;
    var hasNewFolder = (rowPerm & permissions_1.ACL_NEW_FOLDER) > 0;
    return (React.createElement("div", { className: classNames('row', row.type.toLowerCase()), style: style },
        React.createElement("div", { className: "row__column indent-".concat(row.indent, " ").concat(row.type.toLowerCase()) }),
        row.type === 'USER' ? (React.createElement("div", { className: 'row__column narrow' })) : (React.createElement("div", { className: 'row__column narrow group-expander', onClick: function () {
                return data.expandOrCollapseRow([row.group.id], !data.collapsed.includes(row.group.id));
            } },
            React.createElement(sok_ui_1.Icon, { className: data.collapsed.includes(row.group.id)
                    ? 'fa-chevron-down'
                    : 'fa-chevron-up' }))),
        React.createElement("div", { className: 'row__column narrow icon-column' }, (0, utils_1.getIcon)(row)),
        React.createElement("div", { className: "row__column __".concat(row.type === 'USER' ? 'user' : 'group') }, row.type === 'USER' ? (React.createElement("div", { className: 'user-row' },
            React.createElement("div", { className: 'user-info' },
                React.createElement("div", { className: 'userName' },
                    row.user.firstName,
                    " ",
                    row.user.lastName),
                React.createElement("div", { className: 'userEmail' }, row.user.email)))) : ((0, utils_1.getGroupName)(row.group))),
        React.createElement("div", { className: "row__column fill-".concat(2 - row.indent, " ").concat(row.type.toLowerCase()) }),
        row.type === 'USER' ? (React.createElement("div", { className: 'row__column __company' }, row.type === 'USER' ? row.user.company : '')) : (React.createElement(React.Fragment, null,
            React.createElement("div", { key: 'read', className: 'row__column __read' },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: '', onChange: function () {
                        var groups;
                        if (row.type === 'CATEGORY') {
                            var cat = data.groups.find(function (x) { return x.category.id == row.group.id; });
                            groups = cat ? cat.groups.map(function (x) { return x.uuid; }) : [];
                        }
                        else {
                            groups = [row.group.uuid];
                        }
                        data.updatePermission(groups, data.selectedFolder, permissions_1.ACL_READ, false, !hasReadable);
                    }, value: hasReadable, disabled: disabled || data.disableAll })),
            React.createElement("div", { key: 'write', className: 'row__column __write' },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: '', onChange: function () {
                        var groups;
                        if (row.type === 'CATEGORY') {
                            var cat = data.groups.find(function (x) { return x.category.id == row.group.id; });
                            groups = cat ? cat.groups.map(function (x) { return x.uuid; }) : [];
                        }
                        else {
                            groups = [row.group.uuid];
                        }
                        data.updatePermission(groups, data.selectedFolder, permissions_1.ACL_WRITE, hasWritable ? hasNewFolder : true, !hasWritable);
                    }, value: hasWritable, disabled: disabled || data.disableAll })),
            React.createElement("div", { key: 'delete', className: 'row__column __delete' },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: '', onChange: function () {
                        var groups;
                        if (row.type === 'CATEGORY') {
                            var cat = data.groups.find(function (x) { return x.category.id == row.group.id; });
                            groups = cat ? cat.groups.map(function (x) { return x.uuid; }) : [];
                        }
                        else {
                            groups = [row.group.uuid];
                        }
                        data.updatePermission(groups, data.selectedFolder, permissions_1.ACL_DELETE, hasWritable ? hasNewFolder : true, !hasDeletable);
                    }, value: hasDeletable, disabled: disabled || data.disableAll })),
            React.createElement("div", { key: 'new_folder', className: 'row__column __subfolders' },
                React.createElement(sok_ui_1.Input, { type: 'checkbox', label: '', onChange: function () {
                        var groups;
                        if (row.type === 'CATEGORY') {
                            var cat = data.groups.find(function (x) { return x.category.id == row.group.id; });
                            groups = cat ? cat.groups.map(function (x) { return x.uuid; }) : [];
                        }
                        else {
                            groups = [row.group.uuid];
                        }
                        data.toggleNewFolderPermission(groups, data.selectedFolder, !hasNewFolder);
                    }, disabled: disabled || data.disableAll || !hasWritable, value: hasNewFolder }))))));
});
exports.PermissionList = enhance(function (props) {
    if (!props.groups || !props.selectedFolder || props.processing) {
        return (React.createElement("div", { key: 'loading', className: 'loading-spinner' },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    var perms = getPermission(props.processing, props.processed, props.selectedFolder);
    var itemData = createRowData(props.groups, props.processed ? props.items : [], props.expandOrCollapseRow, props.permissions.collapsed, perms, props.disableAll, props.selectedFolder.getValue().uuid, props.updatePermission, props.toggleNewFolderPermission);
    return (React.createElement("div", { className: 'team-members-permission-list-view-list-container' },
        React.createElement("div", { className: 'sok-list-content team-members-permission-list-view-list ' +
                props.permissions.status.toLowerCase() },
            React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props, { perms: perms })), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
            })),
        (props.permissionStatus === 'FETCHING' ||
            props.saveStatus === 'SAVING') && (React.createElement("div", { key: 'fetch', className: 'loading-spinner' },
            React.createElement(sok_ui_1.LoadingSpinner, null)))));
});
